module.exports = __webpack_public_path__ + "img/footer_toggle_2.bdc9abdf.png";